import 'core-js/fn/array/find';
import 'core-js/fn/array/from';
import 'core-js/fn/array/includes';
import 'custom-event-polyfill';



// WEBPACK FOOTER //
// src/scripts/lib/polyfills.js